import React from 'react';
import { Button } from 'primereact/button';

const DownloadButton = ({ loading, onDownload }) => {
  return (
    <Button
      loading={loading}
      link
      onClick={onDownload}
      icon={'pi pi-download'}
    />
  );
};

export default React.memo(DownloadButton);
